import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaGlobe } from 'react-icons/fa';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
  };

  const currentLang = i18n.language || 'en';

  return (
    <div className="relative inline-block">
      <button
        onClick={() => changeLanguage(currentLang === 'en' ? 'id' : 'en')}
        className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gradient-to-r from-maroon-700 to-maroon-800 hover:from-maroon-600 hover:to-maroon-700 transition-all duration-300 text-white font-semibold shadow-md hover:shadow-lg hover:scale-105"
        aria-label="Switch language"
      >
        <FaGlobe className="text-lg" />
        <span className="uppercase text-sm">{currentLang === 'en' ? 'EN' : 'ID'}</span>
      </button>
    </div>
  );
};

export default LanguageSwitcher;
